import { render } from "./PageTree.vue?vue&type=template&id=43d95063&scoped=true"
import script from "./PageTree.vue?vue&type=script&lang=js"
export * from "./PageTree.vue?vue&type=script&lang=js"

import "./PageTree.vue?vue&type=style&index=0&id=43d95063&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d95063"]])

export default __exports__